import { useEffect, useState } from 'react';
import ModalDialog from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { RequestMethod, pepApiRequest, useStatefulApi } from 'src/services';
import { generatePath, useParams } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { useStoreUnitActions } from 'src/redux/helpers';
import { SiteClusters, SolutionSiteEdgeServiceItem } from '../../types';
import solutionsStore, { useSolutionDetails } from '../../redux';
import { SolutionEdgeServiceFormFields } from '../formFields';
import {
  API_SOLUTION_DETAILS,
  API_SOLUTION_SITES_CREATE_NANOMQ_SERVICE,
} from '../../constants';

type Props = {
  title: string;
  item: SolutionSiteEdgeServiceItem;
  open: boolean;
  onClose: () => void;
  siteId: string;
  siteName: string;
  setServiceUrl?: any;
};

function SolutionSiteServiceUrlEditModal({
  siteId,
  siteName,
  item,
  title,
  setServiceUrl,
  open,
  onClose,
}: Props) {
  const { solutionId } = useParams();
  const { showAlert } = useAlert();
  const [url, setUrl] = useState<
    SolutionSiteEdgeServiceItem | string | undefined
  >(item);
  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generatePath(API_SOLUTION_SITES_CREATE_NANOMQ_SERVICE, {
          solutionId,
          siteId,
        }),
        params: { endpoint: params.nanoMQServiceUrl },
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: `${siteName} NanoMQ Service URL is modified`,
        text: 'Site NanoMQ Service URL has been modified successfully.',
      });
      onClose();
      pepApiRequest({
        method: RequestMethod.Get,
        url: generatePath(API_SOLUTION_DETAILS, {
          solutionId,
        }),
      }).then((response) => {
        const url: SiteClusters | undefined = response?.siteClusters?.find(
          (cluster) => cluster?.siteId === siteId
        );
        setServiceUrl(url?.nanoMQServiceUrl);
      });
    }
  );

  const handleChange = (event) => {
    setUrl(event.target.value);
  };

  const [form, handleSubmit] = useForm({
    values: item,
    fields: SolutionEdgeServiceFormFields(url, handleChange),
    onSubmit,
  });

  return (
    <ModalDialog
      data-testid="modal-dialog"
      open={open}
      title={`Edit NanoMQ Service URL : ${siteName} `}
      titleStyle={{
        fontSize: '18px',
        fontFamily: 'Stolzl',
        fontWeight: 500,
      }}
      maxWidth="sm"
      loading={loading}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Submit"
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionSiteServiceUrlEditModal;
